import { Link, Element } from "react-scroll";
import { ReactComponent as Logo } from './assets/logoCpoint.svg';
import Cpoint from "./views/Cpoint";
import Nosotros from "./views/Nosotros";
import Beneficios from "./views/Beneficios";
import Comentarios from "./views/Comentarios";
import Opinion from "./views/Opinion";
import Contact from "./views/Contact";
import { FaFacebook, FaInstagram, FaWhatsapp } from "react-icons/fa";
import useModal from "./hooks/useModal";
import Modal from "./components/Modal";
import manual from "./assets/manual.pdf";
import { useState } from "react";
import { FiMenu, FiX } from "react-icons/fi";

const Header = () => {
  const activo = "underline decoration-yellow-400 decoration-2 underline-offset-4";
  const { open, close, isOpen } = useModal();
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => setMenuOpen(!menuOpen);
  const closeMenu = () => setMenuOpen(false);

  const navItems = (
    <>
      <Link onClick={closeMenu} className="cursor-pointer" activeClass={activo} spy={true} to="inicio" smooth={true} duration={500}>Cpoint</Link>
      <Link onClick={closeMenu} className="cursor-pointer" activeClass={activo} spy={true} to="nosotros" smooth={true} duration={500}>Nosotros</Link>
      <Link onClick={closeMenu} className="cursor-pointer" activeClass={activo} spy={true} to="beneficios" smooth={true} duration={500}>Beneficios</Link>
      <Link onClick={closeMenu} className="cursor-pointer" activeClass={activo} spy={true} to="opinion" smooth={true} duration={500}>Opinión</Link>
      <Link onClick={closeMenu} className="cursor-pointer" activeClass={activo} spy={true} to="contactanos" smooth={true} duration={500}>Contáctanos</Link>
      <button onClick={() => { open(); closeMenu(); }} className="hover:underline decoration-yellow-400 decoration-2 underline-offset-4">
        Manual org. y de procedimientos
      </button>
    </>
  );

  return (
    <header className="fixed top-0 left-0 w-full z-50 bg-white shadow px-4 py-3 flex justify-between items-center">
      <Logo className="w-auto h-12" />

      {/* Desktop menu */}
      <nav className="hidden md:flex gap-6 text-sm font-medium">
        {navItems}
      </nav>

      {/* Mobile toggle button */}
      <div className="md:hidden">
        <button onClick={toggleMenu} aria-label="Toggle Menu">
          {menuOpen ? <FiX size={28} /> : <FiMenu size={28} />}
        </button>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <div className="absolute top-full left-0 w-full bg-white shadow-md flex flex-col items-start gap-4 p-4 text-sm font-medium z-40">
          {navItems}
        </div>
      )}

      {/* Modal */}
      {isOpen && (
        <Modal title="Manual organizacional" onClose={close}>
          <iframe src={manual} className="w-full h-[65vh]" title="Manual org. y de procedimientos" />
        </Modal>
      )}
    </header>
  );
};

const Footer = () => (
    <footer className="h-fit w-full grid grid-cols-1 md:grid-cols-2 p-4 bg-[#1D1D1E] shadow text-white">
      <div className="flex flex-col justify-end items-start gap-2">
        <Logo className="w-auto h-16" />
        <p> Teléfono: 2211032592 </p>
        <p> E-mail: cpoint2021@outlook.com </p>
      </div>
      <div className="flex flex-col justify-end items-start gap-2">
        <p> 51 PONIENTE, #1110, LOCAL 6 COLONIA PRADOS DE AGUA AZUL, CP 72420, PLAZA METROPOLITAN, CIUDAD DE PUEBLA. </p>
        <p> Nosotros también estamos aquí: </p>
        <div className="flex flex-row gap-6 text-yellow-300">
          <a href="https://www.facebook.com/people/CPoint/100083374260873/#" className="cursor-pointer" target="_blank" rel="noopener noreferrer">
            <FaInstagram size={27} />
          </a>
          <a href="https://www.instagram.com/cpoint2015/" className="cursor-pointer" target="_blank" rel="noopener noreferrer">
            <FaFacebook size={27} />
          </a>
          <a href="https://api.whatsapp.com/send/?phone=522211032592&text&type=phone_number&app_absent=0" className="cursor-pointer" target="_blank" rel="noopener noreferrer">
            <FaWhatsapp size={27} />
          </a>
        </div>
      </div>
    </footer>
);

function App() {
  return (
    <div>
      <Header/>
      <Element name="inicio"> <Cpoint/> </Element>
      <Element name="nosotros"> <Nosotros/> </Element>
      <Element name="beneficios"> <Beneficios/> </Element>
      <Comentarios/>
      <Element name="opinion"> <Opinion/> </Element>
      <Element name="contactanos"> <Contact/> </Element>
      <Footer/>
    </div>
  );
}

export default App;
